import { map, switchMap } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { Command, CommandBase } from '../../../core/model/command';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { invoiceCommand } from '../../command/unpaid-invoice';
import { RegisterPaymentFormComponent } from '../../component/register-payment-form/register-payment-form.component';
import { Invoice } from '../../model/invoice';
import { Observable, of } from 'rxjs';
import { MessageService } from '../../../core/service/message.service';
import { RegulateFromBalanceFormComponent } from '../../component/regulate-from-balance-form/regulate-from-balance-form.component';
import { ContactService } from '../../../rent/service/data/contact.service';
import { Money } from '../../../core/model/money';
import { InvoiceService } from '../data/invoice.service';

@Injectable()
export class RegulateFromBalanceCommandHandler implements ICommandHandler {
  constructor(
    private _actionWindowservice: ActionWindowService,
    private _injector: Injector,
    private _messageService: MessageService,
    private _contactService: ContactService,
    private _invoiceService: InvoiceService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command && command.context instanceof Invoice) {
      if (!command.context.attestedDate || !command.context.attestedDate.hasValue()) {
        this._messageService.showMessage('INVOICE.INFORMATION_TEXT.INVOICE_CERTIFIED_BEFORE_REGISTER_PAYMENT');
        return false;
      }
      return command.id === invoiceCommand.regulateFromBalance;
    }
    return false;
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof Command) {
      var getInvoiceId = command.context.invoiceRecipientContactId
        ? of(command.context.invoiceRecipientContactId as string)
        : this._invoiceService.get(command.context.id).pipe(map(inv => inv.invoiceRecipientContactId));
      return getInvoiceId.pipe(
        switchMap(contactId =>
          this._contactService.getContactBalance(contactId, command.context.currencyCode).pipe(
            map(amount => {
              return { invoiceId: command.context.id, invoiceBalance: command.context.remainingAmount, balance: amount };
            }),
            switchMap(val =>
              this._actionWindowservice.open(RegulateFromBalanceFormComponent, this._injector, null, val).pipe(
                map(regulatedAmount => {
                  if (command.context instanceof Invoice) {
                    command.context.remainingAmount = new Money(
                      command.context.remainingAmount.currencyCode,
                      command.context.remainingAmount.amount - regulatedAmount.amount
                    );
                  }
                })
              )
            )
          )
        )
      );
    }
  }
}
